<template>
    <div>
        <polls :title="$t('pollDetails.vote')"
            :polls="pollsToShow"
            :isInitialLoad="isInitialLoad"
        >
            <div v-observe-visibility="isEnabled ? loadMore : false"
                class="observer"
            />
        </polls>
    </div>
</template>

<script>
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import polls from '@webapp/components/poll/polls.vue';

export default {
    name: 'vote',
    components: {
        polls,
    },
    data() {
        return {
            isInitialLoad: true,
            isEnabled: true,
        };
    },
    computed: {
        ...mapGetters([
            'surveys',
            'surveysLoading',
            'surveysCurrentPage',
            'isSurveysLastPage',
            'surveysLastPage',
            'scheduledSurveysOrdered',
            'openedSurveysOrdered',
            'currentSurveysListPartnerId',
        ]),

        pollsToShow() {
            return [...this.scheduledSurveysOrdered, ...this.openedSurveysOrdered];
        },
    },
    async mounted() {
        // Do not refetch the surveys if the user is navigating back to this page
        if (this.pollsToShow && this.pollsToShow.length > 0 && this.currentSurveysListPartnerId === '') {
            this.isInitialLoad = false;
        } else {
            await this.fetchSurveyPage(1);
            this.isInitialLoad = false;
        }
    },
    methods: {
        ...mapActions(['fetchSurveys']),

        loadMore(isVisible) {
            if ((this.surveysCurrentPage + 1) > this.surveysLastPage || this.isInitialLoad || !isVisible) {
                return;
            }

            this.fetchSurveyPage(this.surveysCurrentPage + 1);
        },

        async fetchSurveyPage(page = 1) {
            await this.fetchSurveys({
                statuses: ['scheduled', 'opened'],
                details: ['surveyTranslations'],
                orderBy: 'closeAt',
                direction: 'asc',
                page,
                canAppend: page > 1,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.observer {
    margin-bottom: 2rem;

    @include min-width(lg) {
        margin-bottom: 0;
    }
}
</style>